import React from "react";
import RK_W from "../../../../images/RK_W.png";
import KT_W from "../../../../images/KT_W.png";
import BP_W from "../../../../images/BP_W.png";
import QN_W from "../../../../images/QN_W.png";
import "./promotion.css";

const PromotionWhite = props => {
	return (
		<div className="promotion">
			<div className={props.whitePromotionVisible ? "promotion-visible" : "promotion-hidden"}>
				<div className="promotion-container">
					<h5 className="promotion-title">PROMOTE PIECE TO:</h5>
					<div className="promotion-background">
						<img src={KT_W} alt="KT_W" className="option-white" onClick={() => props.handlePiecePromotion("knight", "white")} />
						<img src={BP_W} alt="BP_W" className="option-white" onClick={() => props.handlePiecePromotion("bishop", "white")} />
						<img src={RK_W} alt="RK_W" className="option-white" onClick={() => props.handlePiecePromotion("rook", "white")} />
						<img src={QN_W} alt="QN_W" className="option-white" onClick={() => props.handlePiecePromotion("queen", "white")} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PromotionWhite;
